import { IDENTITY_SERVICE_URL as IDENTITY_URL, ADMIN_API_SERVICE_BASE_URL as ADMIN_API_URL } from 'src/config/constants';

// Auth
export const AUTH_LOGOUT_URL = `${IDENTITY_URL}logout`;
export const AUTH_LOGIN_URL = `${IDENTITY_URL}login`;

// admin
export const USERS_LIST_ADMIN_URL = `${ADMIN_API_URL}/users`;
export const USER_TRANSACTIONS_ADMIN_URL = `${ADMIN_API_URL}/users/{id}/transactions`;
export const UPDATE_USER_TRANSACTION_STATUS_ADMIN_URL =
  `${ADMIN_API_URL}/users/{userId}/transactions/{transactionId}`;
export const USER_INFO_ADMIN_URL = `${ADMIN_API_URL}/users/{id}`;
export const USER_RESOURCES_ADMIN_URL = `${ADMIN_API_URL}/users/{id}/resources`;
export const RESOURCES_ADMIN_URL = `${ADMIN_API_URL}/resources`;
export const UPDATE_USER_RESOURCE_ADMIN_URL =
  `${ADMIN_API_URL}/users/{userId}/resources/{resourceName}`;
export const LIST_TAGS_URL = `${ADMIN_API_URL}/tags`;
export const ADMIN_APP_SETTINGS_URL = `${ADMIN_API_URL}/app-settings`;
export const USERS_LOGS_URL = `${ADMIN_API_URL}/logs/organizations`;
export const ORGANIZATION_PROFILE_LOGS_URL =
  `${ADMIN_API_URL}/logs/organizations/{OrgId}/Users`;
export const ORGANIZATION_TRANSACTIONS_LOGS_URL =
  `${ADMIN_API_URL}/logs/organizations/{OrgId}/Transactions`;
export const ORGANIZATION_RESOURCES_LOGS_URL =
  `${ADMIN_API_URL}/logs/organizations/{OrgId}/Resources`;
export const RESOURCES_LOGS_URL = `${ADMIN_API_URL}/logs/resources`;
export const TAGS_LOGS_URL = `${ADMIN_API_URL}/logs/tags`;

// Client Credentials
export const CLIENT_CREDENTIALS_API_KEY_URL = `${ADMIN_API_URL}/client-credentials/api-key/{clientId}`;
export const CLIENT_CREDENTIALS_USER_URL = `${ADMIN_API_URL}/client-credentials/user/{userId}`;
export const CLIENT_CREDENTIALS_RESOURCE_URL = `${ADMIN_API_URL}/client-credentials/resource/{resourceName}`;
export const CLIENT_CREDENTIALS_CLIENT_URL = `${ADMIN_API_URL}/client-credentials/client/{clientId}`;
export const CLIENT_CREDENTIALS_ALL_CLIENTS_URL = `${ADMIN_API_URL}/client-credentials/clients`;
export const CLIENT_REGISTRATION_URL = 'clients/register/global';
export const TEST_SECURE_URL = 'test/secure';
export const REVOKE_CREDENTIAL_URL = `${ADMIN_API_URL}/client-credentials/revoke/{applicationId}`;
export const UPDATE_CLIENT_DESCRIPTION_URL = `${ADMIN_API_URL}/client-credentials/description/{credentialId}`;

// account
export const DOWNLOAD_APP_URL = '/download';

export const ADMIN_ACTIONS_URL = `${ADMIN_API_URL}/actions`;

// Bulk User Operations
export const BULK_UPDATE_USERS_URL = `${ADMIN_API_URL}/users/bulk-update`;
export const BULK_UPDATE_USERS_TRANSACTIONAL_URL = `${ADMIN_API_URL}/users/bulk-update-transactional`;
export const BULK_UPDATE_ACCOUNT_STATUS_URL = `${ADMIN_API_URL}/users/bulk-update/account-status`;
export const BULK_UPDATE_TAGS_URL = `${ADMIN_API_URL}/users/bulk-update/tags`;
export const BULK_UPDATE_RESOURCES_URL = `${ADMIN_API_URL}/users/bulk-update/resources`;
export const BULK_UPDATE_SCOPES_URL = `${ADMIN_API_URL}/users/bulk-update/scopes`;

// Bulk Operations Audit Logs
export const BULK_OPERATIONS_AUDIT_LOGS_URL = `${ADMIN_API_URL}/logs/bulk-user-operations`;

// Error Messages
export const ERROR_MESSAGES_URL = `${ADMIN_API_URL}/error-messages`;
export const ERROR_MESSAGE_BY_CODE_URL = `${ADMIN_API_URL}/error-messages/{errorCode}`;
export const ERROR_MESSAGES_CATEGORIES_URL = `${ADMIN_API_URL}/error-messages/categories`;
export const ERROR_MESSAGES_INTERPOLATE_URL = `${ADMIN_API_URL}/error-messages/interpolate`;
export const ERROR_MESSAGES_REFRESH_CACHE_URL = `${ADMIN_API_URL}/error-messages/refresh-cache`;
export const ERROR_MESSAGES_EXPORT_TRANSLATIONS_TEMPLATE_URL =
  `${ADMIN_API_URL}/error-messages/export-translations/template`;
export const ERROR_MESSAGES_EXPORT_TRANSLATIONS_CSV_URL =
  `${ADMIN_API_URL}/error-messages/export-translations/csv`;
export const ERROR_MESSAGES_IMPORT_TRANSLATIONS_CSV_URL =
  `${ADMIN_API_URL}/error-messages/import-translations/csv`;
export const ERROR_MESSAGES_EXPORT_TRANSLATIONS_URL =
  `${ADMIN_API_URL}/error-messages/export-translations`;
export const ERROR_MESSAGES_IMPORT_TRANSLATIONS_DRY_RUN_URL =
  `${ADMIN_API_URL}/error-messages/import-translations/dry-run`;
export const ERROR_MESSAGES_IMPORT_TRANSLATIONS_URL =
  `${ADMIN_API_URL}/error-messages/import-translations`;
